/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface GetDataSecondStage200ResponseDataMktuListInner
 */
export interface GetDataSecondStage200ResponseDataMktuListInner {
  /**
   * Номер класса МКТУ (1–45)
   * @type {number}
   * @memberof GetDataSecondStage200ResponseDataMktuListInner
   */
  classNum: number
  /**
   * Наименование товаров/услуг класса
   * @type {string}
   * @memberof GetDataSecondStage200ResponseDataMktuListInner
   */
  text: string
}

/**
 * Check if a given object implements the GetDataSecondStage200ResponseDataMktuListInner interface.
 */
export function instanceOfGetDataSecondStage200ResponseDataMktuListInner(
  value: object
): value is GetDataSecondStage200ResponseDataMktuListInner {
  if (!('classNum' in value) || value['classNum'] === undefined) return false
  if (!('text' in value) || value['text'] === undefined) return false
  return true
}

export function GetDataSecondStage200ResponseDataMktuListInnerFromJSON(
  json: any
): GetDataSecondStage200ResponseDataMktuListInner {
  return GetDataSecondStage200ResponseDataMktuListInnerFromJSONTyped(
    json,
    false
  )
}

export function GetDataSecondStage200ResponseDataMktuListInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataSecondStage200ResponseDataMktuListInner {
  if (json == null) {
    return json
  }
  return {
    classNum: json['classNum'],
    text: json['text'],
  }
}

export function GetDataSecondStage200ResponseDataMktuListInnerToJSON(
  value?: GetDataSecondStage200ResponseDataMktuListInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    classNum: value['classNum'],
    text: value['text'],
  }
}
